import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css' // 引入 Tailwind CSS 样式

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'; // 引入 Element Plus 样式

createApp(App).use(ElementPlus).mount('#app');